<template>
    <div class="pa-4 mt-8"  style="border: 1px dashed white;">
        <!-- TODO emit no noData para nao aparecer esse componente -->
        <h3 id="filter-title-text">Selecione um período para consultar os dados:</h3>
        <v-form class="mt-4" ref="form">
            <v-row align="center">
                <v-col class="pr-0" cols="8" md="2" >
                    <div class="pr-6 form-input-group">
                        <v-select
                            id="type"
                            :items="types"
                            v-model="type"
                            outlined
                            dense
                            hide-details
                            item-color="secondary lighten-1"
                            color="secondary lighten-1"
                        >
                        </v-select>
                        <label for="type">Tipo</label>
                    </div>
                </v-col>

                <v-col class="pa-0" cols="12" md="10">
                    <v-radio-group v-if="type === 'Diário'" class="pt-8" v-model="period" :column="isMobile" mandatory>
                        <v-radio
                            class="mr-6"
                            v-for="(item, index) in dailyPeriods"
                            :key="index"
                            :label="item.label"
                            :value="item.interval"
                            color="secondary lighten-1"
                        ></v-radio>

                        <v-radio
                            class="mr-6"
                            label="Outro período"
                            value="otherPeriod"
                            color="secondary lighten-1"
                        ></v-radio>

                        <v-col cols="12" sm="6" md="4" class="pl-0">
                            <date-field
                                ref="otherPeriodField"
                                type="daily"
                                :disabled="period !== 'otherPeriod'"
                                @cancelDateSelected="cancelDateSelected"
                                @applyDateSelected="applyDateSelected($event)"
                            ></date-field>
                        </v-col>
                    </v-radio-group>

                    <v-radio-group v-if="type === 'Mensal'" class="pt-8" v-model="period" :column="isMobile" mandatory>
                        <v-radio
                            class="mr-6"
                            v-for="(item, index) in monthlyPeriods"
                            :key="index"
                            :label="item.label"
                            :value="item.interval"
                            color="secondary lighten-1"
                        ></v-radio>

                        <v-radio
                            class="mr-6"
                            value="otherPeriod"
                            label="Outro período"
                            color="secondary lighten-1"
                        ></v-radio>
                        <date-field
                            ref="otherPeriodField"
                            type="monthly"
                            :disabled="period !== 'otherPeriod'"
                            @cancelDateSelected="cancelDateSelected"
                            @applyDateSelected="applyDateSelected($event)"
                        ></date-field>
                    </v-radio-group>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import moment from 'moment';
import DateField from './DateField.vue';
export default
{
    name: 'SearchPeriodDate',
    props:['basin'],
    components: { DateField },
    data:()=>({
        types:['Diário', 'Mensal'],
        type: undefined,
        period: undefined,
        dailyPeriods:[
            {label: 'Últimos 7 dias', interval: 7},
            {label: 'Últimos 30 dias', interval: 30},
            {label: 'Últimos 60 dias', interval: 60}
        ],
        monthlyPeriods:[
            {label: 'Últimos 6 meses', interval: 6},
            {label: 'Últimos 12 meses', interval: 12}
        ],
        beforeDate: undefined,
        currentDate: undefined
    }),
    mounted(){
        setTimeout(()=>{
            this.initialize();
        }, 100);
    },
    watch:{
        basin(value){
            if(value){
                this.initialize();
            }
        },
        type(value){
            if(value){
                if(value === 'Diário'){
                     this.period = this.dailyPeriods[0].interval;
                }else{
                     this.period = this.monthlyPeriods[0].interval;
                }
            }
        },
        period(value){
            if(value !== 'otherPeriod'){
                const stringFormat = this.type === 'Diário' ? 'YYYY-MM-DD' : 'YYYY-MM';
                const unit = this.type === 'Diário' ? 'days' : 'months';
                const startDate = moment().subtract(value - 1, unit).locale('pt-br').format(stringFormat);
                const endDate = moment().locale('pt-br').format(stringFormat);
                const date =  [startDate, endDate];
                this.applyDateSelected(date);
            }

            // setTimeout(()=>{
            if (this.$refs.otherPeriodField) {
                this.$refs.otherPeriodField.backOldDateValue(this.currentDate);
            }
            // }, 50);
        }
    },
    computed:{
        isMobile(){
            return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
        }
    },
    methods:{
        initialize(){
            this.type = this.types[0];
            this.period = this.dailyPeriods[0].interval;
        },
        cancelDateSelected(){
            this.$refs.otherPeriodField.backOldDateValue(this.currentDate);
        },
        applyDateSelected(date){
            this.beforeDate = this.currentDate;
            this.currentDate = date;
            this.$emit('applyPeriod', {period: this.currentDate, type: this.type});
        }
    }
}
</script>

<style scoped>
    #filter-title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
    }

    label{
        order: -1;
        color: #ffffff;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 8px;
    }

    .v-input:focus-within + label{
        color: var(--v-secondary-lighten1);
    }

    .form-input-group{
        display: flex;
        flex-direction: column;
    }
</style>